import { AutomationVariableDataType } from 'pages/AutomationEngine/types';
import { TFunction } from 'react-i18next';

export type FieldValidationType =
  | 'required'
  | 'deleted'
  | 'deleted-field'
  | 'deleted-variable';
export type FieldValidationFieldType = AutomationVariableDataType;
export type FieldValidationFallbackFieldType = AutomationVariableDataType &
  'fallback';
export type FieldValidation = Record<
  string,
  {
    type: FieldValidationType;
    fieldType: FieldValidationFieldType | undefined;
    deletedConditions?: string[];
    condition?: Record<string, string[]>;
    isSelect?: boolean;
    deletedNameLookup?: Record<string, string>;
    errorMessage?: string;
  }[]
>;

//
export const fieldValidate = (
  fieldData: any,
  fieldValidation: FieldValidation,
  sourceSubtype: AutomationVariableDataType | undefined,
  checkRequired: boolean,
  t: TFunction
) => {
  let errorsReturned: {
    valid: boolean;
    errors: Record<string, string[]>[];
  } = { valid: true, errors: [] };
  if (!fieldData) {
    return { valid: false, errors: [] };
  }

  if (Object.keys(fieldValidation).length) {
    for (const [key, check] of Object.entries(fieldValidation)) {
      for (const {
        type,
        fieldType,
        condition,
        isSelect,
        deletedConditions,
        deletedNameLookup,
        errorMessage,
      } of check) {
        let requiredConditional = true;

        // figure out conditonal values
        if (condition) {
          const [[fieldName, requiredValues]] = Object.entries(condition);
          const fieldValue =
            fieldData[fieldName]?.value || fieldData[fieldName];
          requiredConditional = requiredValues.includes(fieldValue);
        }

        if (type === 'required' && checkRequired && requiredConditional) {
          const hasValue = fieldData?.[key] && Boolean(fieldData?.[key]);
          if (!hasValue) {
            errorsReturned = {
              valid: false,
              errors: [
                ...errorsReturned.errors,
                {
                  [key]: [
                    isSelect
                      ? t('Please choose an option.')
                      : t('This field may not be blank.'),
                  ],
                },
              ],
            };
          }
        }

        if (
          (type === 'deleted' &&
            ((sourceSubtype && fieldType === sourceSubtype) ||
              !sourceSubtype) &&
            (deletedConditions || []).includes(fieldType!)) ||
          ['deleted-field', 'deleted-variable'].includes(type)
        ) {
          const isDeleted = Boolean(fieldData?.[key]?.deleted);
          const deletedName = deletedNameLookup
            ? (fieldType && deletedNameLookup?.[fieldType]) ||
              deletedNameLookup?.fallback
            : t('Record');

          if (isDeleted) {
            errorsReturned = {
              valid: false,
              errors: [
                ...errorsReturned.errors,
                {
                  [key]: [
                    errorMessage ||
                      t('This {{deletedName}} has been deleted.', {
                        deletedName,
                      }),
                  ],
                },
              ],
            };
          }
        }
      }
    }
  }
  return errorsReturned;
};
